/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type activities_ChildCurrentStateResponse = {
    /**
     * CheckInSource is "door_mode" when the child's latest check-in of the day was
     * self-reported on the door-mode tablet (#2027). Omitted otherwise.
     */
    check_in_source?: activities_ChildCurrentStateResponse.check_in_source;
    check_in_time?: string;
    /**
     * CheckOutSource is "door_mode" when the day's latest check event is a check-out the
     * child self-reported on the door-mode tablet (#2027). Omitted otherwise.
     */
    check_out_source?: activities_ChildCurrentStateResponse.check_out_source;
    /**
     * CheckOutTime is the time of the day's check-out (#1897): set when the child's latest
     * check-in or check-out of the requested org-local day is a check-out, null otherwise.
     */
    check_out_time?: string | null;
    child_id?: string;
    /**
     * DiaperSinceMinutes and DiaperState are the child's diaper clock (care alerts, stage 0):
     * the minutes since the last toilet entry or the check-in, and its state (ok, due_soon,
     * overdue, escalated, paused while asleep). null unless the organisation has the diaper
     * check on, the child is flagged "uses diapers" and checked in, and the date is today.
     */
    diaper_since_minutes?: number | null;
    diaper_state?: activities_ChildCurrentStateResponse.diaper_state | null;
    is_checked_in?: boolean;
    is_napping?: boolean;
    last_feeding_time?: string;
    last_toilet_time?: string;
    last_updated?: string;
    nap_start_time?: string;
    picked_up_by?: string;
    /**
     * PickupNoticeCollectorName is the collector of the child's active same-day pick-up
     * notice on the requested date (#1876 D13), for the attendance card. Omitted when
     * there is no notice or the notice read is not wired.
     */
    pickup_notice_collector_name?: string;
};
export namespace activities_ChildCurrentStateResponse {
    /**
     * CheckInSource is "door_mode" when the child's latest check-in of the day was
     * self-reported on the door-mode tablet (#2027). Omitted otherwise.
     */
    export enum check_in_source {
        DOOR_MODE = 'door_mode',
    }
    /**
     * CheckOutSource is "door_mode" when the day's latest check event is a check-out the
     * child self-reported on the door-mode tablet (#2027). Omitted otherwise.
     */
    export enum check_out_source {
        DOOR_MODE = 'door_mode',
    }
    export enum diaper_state {
        OK = 'ok',
        DUE_SOON = 'due_soon',
        OVERDUE = 'overdue',
        ESCALATED = 'escalated',
        PAUSED = 'paused',
    }
}

